<script setup lang='ts'>
  import { KsSkeleton, KsSkeletonWrapper  } from '@aschehoug/kloss'
  import { useCssVar } from '@vueuse/core'

  const skeletonLoadingColor = useCssVar('--color-blue-30')
  const skeletonLoadingColorDark = useCssVar('--color-blue-40')
</script>

<template>
  <KsSkeletonWrapper class="skeleton-wrapper">
    <div class="column">
      <KsSkeleton
        height="128px"
        width="100%"
        :background="skeletonLoadingColor"
      />
      <div class="row">
        <KsSkeleton
          width="2.5em"
          height="2.5em"
          :background="skeletonLoadingColorDark"
          :border-radius="'50%'"
        />
        <KsSkeleton width="80%" :background="skeletonLoadingColor" />
      </div>
      <div class="row">
        <KsSkeleton
          width="2.5em"
          height="2.5em"
          :background="skeletonLoadingColorDark"
          :border-radius="'50%'"
        />
        <KsSkeleton width="40%" :background="skeletonLoadingColor" />
      </div>
      <div class="row">
        <KsSkeleton
          width="2.5em"
          height="2.5em"
          :background="skeletonLoadingColorDark"
          :border-radius="'50%'"
        />
        <KsSkeleton width="60%" :background="skeletonLoadingColor" />
      </div>
      <div class="row">
        <KsSkeleton
          width="2.5em"
          height="2.5em"
          :background="skeletonLoadingColorDark"
          :border-radius="'50%'"
        />
        <KsSkeleton width="80%" :background="skeletonLoadingColor" />
      </div>
    </div>
    <div class="column">
      <KsSkeleton height="100%" :background="skeletonLoadingColorDark" />
    </div>
  </KsSkeletonWrapper>
</template>

<style lang='scss' scoped>
  .skeleton-wrapper {
    background-color: var(--color-lightblue-20);
    border-radius: 16px;
    display: flex;
    height: fit-content;
    width: 100%;

    .row {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: flex-start;
      gap: 24px;
    }

    .column {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 48px;
    }
  }
</style>